import { Serializable } from "../utilities/Serializable";
import { CouponType } from "./CouponType";

export class DailyCouponList extends Serializable {
    
    type: CouponType;
    amounts: number[];    
    cardUuid: string;
    posUuid: string;
    constructor() {
        super();
        this.amounts = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/models/DailyCouponList.ts